var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9712 2.74111C17.9524 2.69675 17.9259 2.65781 17.8916 2.62428L15.3148 0.104928C15.2816 0.072476 15.2406 0.0455409 15.1964 0.028125C15.1521 0.00973558 15.1034 0 15.0547 0H10.2673C10.0649 0 9.9 0.161178 9.9 0.359135V10.4398C9.9 10.6388 10.0649 10.8 10.2673 10.8H17.6316C17.8351 10.8 18 10.6388 18 10.4398V2.87957C18 2.83089 17.9902 2.78438 17.9712 2.74111ZM15.3024 0.9L17.1 2.7H15.3L15.3024 0.9ZM10.8535 9.9L10.8 0.9H14.5218V3.2843C14.5218 3.45197 14.6501 3.58774 14.8085 3.58774H17.1V9.9H10.8535ZM8.07123 2.74111C8.05242 2.69675 8.02587 2.65781 7.99157 2.62428L5.41475 0.104928C5.38156 0.072476 5.34062 0.0455409 5.29637 0.028125C5.25211 0.00973558 5.20343 0 5.15475 0H0.367327C0.164855 0 0 0.161178 0 0.359135V10.4398C0 10.6388 0.164855 10.8 0.367327 10.8H7.73157C7.93515 10.8 8.1 10.6388 8.1 10.4398V2.87957C8.1 2.83089 8.09015 2.78438 8.07123 2.74111ZM5.40235 0.9L7.2 2.7H5.4L5.40235 0.9ZM0.953506 9.9L0.9 0.9H4.62178V3.2843C4.62178 3.45197 4.75007 3.58774 4.9085 3.58774H7.2V9.9H0.953506Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.60bf88cc13edf1c355eaacb623f367f4.svg";
export { ForwardRef as ReactComponent };